import { Button, Group } from '@mantine/core';
import type { RecordingStatusView } from '@/lib/telehealth/chime/chimeRecording';

/**
 * The provider's Stop, Resume or Retry recording control (`providerRecordingView`); nothing when the status offers
 * none. The status itself is the media stage's recording badge, with `view.label` as its tooltip.
 */
export function RecordingStatusBar({
  view,
  busy,
  onStop,
  onResume,
}: {
  view: RecordingStatusView;
  busy: boolean;
  onStop: () => void;
  onResume: () => void;
}): JSX.Element | null {
  if (!view.control) return null;
  return (
    <Group px="md" pt="sm" gap="sm">
      <Button
        size="xs"
        color={view.control.action === 'resume' ? 'red' : undefined}
        variant={view.control.action === 'stop' ? 'default' : 'filled'}
        loading={busy}
        onClick={view.control.action === 'stop' ? onStop : onResume}
      >
        {view.control.label}
      </Button>
    </Group>
  );
}
